import { FC } from 'react';

const DragHandleIcon: FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.5 13C2.32843 13 3 13.6716 3 14.5C3 15.3284 2.32843 16 1.5 16C0.671573 16 0 15.3284 0 14.5C0 13.6716 0.671573 13 1.5 13ZM8.5 13C9.32843 13 10 13.6716 10 14.5C10 15.3284 9.32843 16 8.5 16C7.67157 16 7 15.3284 7 14.5C7 13.6716 7.67157 13 8.5 13ZM1.5 6.5C2.32843 6.5 3 7.17157 3 8C3 8.82843 2.32843 9.5 1.5 9.5C0.671573 9.5 0 8.82843 0 8C0 7.17157 0.671573 6.5 1.5 6.5ZM8.5 6.5C9.32843 6.5 10 7.17157 10 8C10 8.82843 9.32843 9.5 8.5 9.5C7.67157 9.5 7 8.82843 7 8C7 7.17157 7.67157 6.5 8.5 6.5ZM1.5 0C2.32843 0 3 0.671573 3 1.5C3 2.32843 2.32843 3 1.5 3C0.671573 3 0 2.32843 0 1.5C0 0.671573 0.671573 0 1.5 0ZM8.5 0C9.32843 0 10 0.671573 10 1.5C10 2.32843 9.32843 3 8.5 3C7.67157 3 7 2.32843 7 1.5C7 0.671573 7.67157 0 8.5 0Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DragHandleIcon;
